<template>
  <div>
    <b-row class="no-gutters row-title">
      <b-col xl="3" class="text-center text-sm-left mb-3 mb-sm-0 w-auto">
        <h1 class="mr-sm-4 header-main text-uppercase">ข้อมูล ADMIN ID</h1>
      </b-col></b-row
    >
    <div class="content-section bg-border-top">
      <div class="date-section">
        <p>
          วันที่ทำการสมัคร:
          {{ userProfile.createdTime | moment($formatDateTime) }}
        </p>
      </div>
      <b-row class="no-gutters">
        <b-col>
          <div class="">
            <InputText
              textFloat="ชื่อ"
              placeholder="ชื่อ"
              type="text"
              name="firstName"
              v-model="userProfile.firstname"
              isRequired
              class="mr-1"
              :isValidate="$v.userProfile.firstname.$error"
              :v="$v.userProfile.firstname"
            />
          </div>
        </b-col>
        <b-col>
          <div class="">
            <InputText
              textFloat="นามสกุล"
              placeholder="นามสกุล"
              type="text"
              name="lastName"
              v-model="userProfile.lastname"
              isRequired
              class="mr-1"
              :isValidate="$v.userProfile.lastname.$error"
              :v="$v.userProfile.lastname"
            />
          </div>
        </b-col>
      </b-row>

      <b-row class="no-gutters">
        <b-col>
          <div class="">
            <InputText
              textFloat="User ID"
              placeholder="User ID"
              type="text"
              name="id"
              v-model="userProfile.employeeId"
              class="mr-1"
            />
            <!-- :isValidate="$v.userProfile.employeeId.$error"
              :v="$v.userProfile.employeeId" -->
          </div>
        </b-col>
        <b-col>
          <div class="">
            <InputText
              textFloat="Email"
              placeholder="Email"
              type="email"
              name="email"
              isRequired
              v-model="userProfile.email"
              class="mr-1"
              :isValidate="$v.userProfile.email.$error"
              :v="$v.userProfile.email"
            />
          </div>
        </b-col>
      </b-row>

      <b-row class="no-gutters mb-3 mt-1" v-if="$route.params.id != 0">
        <b-col>
          <div class="reset-pw">
            <b-button class="purple-btn">
              <span class="d-none d-sm-inline" @click="showModalResetPassword()"
                >ตั้งค่าหัสผ่านใหม่</span
              >
            </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row class="no-gutters" v-else>
        <b-col>
          <div class="">
            <InputText
              textFloat="รหัสผ่าน"
              placeholder="รหัสผ่าน"
              type="password"
              name="password"
              v-model="userProfile.password"
              class="mr-1"
              detail="(รหัสผ่านจำเป็นจะต้องมีตัวเลขรวมกันอย่างน้อย 6 ตัว เพื่อความปลอดภัย)"
              :isValidate="$v.userProfile.password.$error"
              :v="$v.userProfile.password"
              isRequired
            />
          </div>
        </b-col>
   
        <b-col
          ><div>
            <InputText
              textFloat="ยืนยันรหัสผ่านใหม่"
              placeholder="ยืนยันรหัสผ่านใหม่"
              type="password"
              name="confirmPassword"
              v-model="userProfile.confirmPassword"
              isRequired
              :isValidate="$v.userProfile.confirmPassword.$error"
              :v="$v.userProfile.confirmPassword"
              detail="(รหัสผ่านจำเป็นจะต้องมีตัวเลขรวมกันอย่างน้อย 6 ตัว เพื่อความปลอดภัย)"
            />
          </div>
        </b-col>
      </b-row>

      <p class="mb-1 label-input">
        สถานะการแสดงผล <span class="text-danger">*</span>
      </p>
      <b-row>
        <b-col>
          <div class="switch-status">
            <b-form-checkbox
              v-model="userProfile.enabled"
              name="check-button-status"
              size="lg"
              switch
            >
            </b-form-checkbox>
            <span class="txt-status" v-if="userProfile.enabled">ใช้งาน</span
            ><span class="txt-status" v-else>ไม่ใช้งาน</span>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="1" class="role">
          <span>ตำแหน่ง: </span>
        </b-col>
        <b-col cols="5" class="pr-1">
          <InputSelect
            title=""
            name="role"
            :options="roleList"
            isRequired
            v-model="form.role"
            @onDataChange="onRoleChange($event)"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6" class="pr-1">
          <span>สิทธิการเข้าถึง</span>
          <div class="permission-box mb-4">
            <div class="pt-4 pr-4 pl-4">
              <div v-for="(menu, index) in permissionMenu" :key="index">
                <b-row>
                  <b-col cols="1">
                    <font-awesome-icon
                      icon="chevron-circle-right"
                      v-if="menu.subMenu.length > 0 && !menu.show"
                      class="pointer"
                      @click="showListPermission(index)"
                    />
                    <font-awesome-icon
                      icon="chevron-circle-down"
                      v-if="menu.show"
                      class="pointer"
                      @click="hideListPermission(index)"
                    />
                  </b-col>
                  <b-col cols="1"
                    ><b-checkbox
                      disabled
                      :checked="checkPermission(menu.id)"
                    ></b-checkbox
                  ></b-col>
                  <b-col>
                    <p>{{ menu.name }}</p></b-col
                  >
                </b-row>

                <div class="pl-5" v-if="menu.show">
                  <div v-for="subMenu in menu.subMenu" :key="subMenu.id">
                    <b-row>
                      <b-col cols="1"
                        ><b-checkbox
                          disabled
                          :checked="checkPermission(subMenu.id)"
                        ></b-checkbox
                      ></b-col>
                      <b-col>
                        <p>{{ subMenu.name }}</p>
                      </b-col></b-row
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="mt-3 d-flex justify-content-between">
        <div>
          <b-button class="btn-main-2" @click="cancle">
            ยกเลิก
          </b-button>
        </div>
        <b-button class="btn-main" @click="onSave"> บันทึก </b-button>
      </div>
    </div>
    <ModalResetPassword ref="modalResetPassword" @resetPassword="saveData" />
    <ModalLoading ref="modalLoadingSave" :hasClose="false" />
    <ModalAlert ref="modalSaveSuccess" text="บันทึกสำเร็จ" />
    <ModalAlertError ref="modalSaveAlert" :text="textAlert" />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import ModalResetPassword from "./modal/ModalResetPassword.vue";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import {
  required,
  email,
  minLength,
  helpers,
  sameAs,
  requiredIf
} from "vuelidate/lib/validators";
const alpha = helpers.regex("alpha", /[ก-๙a-zA-Z]*$/);
const passwordNumber = helpers.regex("alpha", /[0-9]+/);
export default {
  components: {
    InputText,
    InputSelect,
    ModalResetPassword,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data() {
    return {
      userProfile: {},
      roleId: [],
      form: {
        role: "",
      },
      roleList: [],
      rolePermission: [],
      permissionMenu: [],
      textAlert: "",
      exPermission: [
        {
          main: { name: "Content", check: true },
          parent: [
            { name: "Banner", check: false },
            { name: "Block", check: false },
          ],
        },
        {
          main: { name: "Cataing", check: true },
          parent: [
            { name: "Catagory List", check: true },
            { name: "Product List", check: true },
          ],
        },
        {
          main: { name: "Website", check: true },
          parent: [
            {
              name: "Finance",
              check: true,
              parent: [
                { name: "Withdraw", check: true },
                { name: "Point List", check: true },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.getRole();
    this.getData();
    this.getPermission();
  },
  methods: {
    async getData() {
      await this.axios
        .get(`${this.$baseUrl}/adminRole/${this.$route.params.id}`)
        .then((data) => {
          if (data.result) {
            this.userProfile = data.detail.userProfile;
            if(this.$route.params.id == 0) {
              this.userProfile.createdTime = new Date();
            }
            this.roleId = data.detail.roleId;
            if (data.detail.roleId.length > 0) {
              this.form.role = data.detail.roleId[0];
            } else {
              this.form.role = 1;
            }
          }
        });
    },
    async getRole() {
      let allRole = [];
      await this.axios.get(`${this.$baseUrl}/adminRole`).then((data) => {
        if (data.result) {
          for (let i = 0; i < data.detail.length; i++) {
            let role = { value: data.detail[i].id, text: data.detail[i].name };
            allRole.push(role);
          }
          this.rolePermission = data.detail;
        }
      });

      this.roleList = allRole;
    },
    async getPermission() {
      await this.axios
        .get(`${this.$baseUrl}/admin/menuHierarchy`)
        .then((data) => {
          if (data.result) {
            this.permissionMenu = data.detail.mainMenu;
          }
        });
    },
    cancle() {
      this.$router.go(-1);
    },
    async saveData(formPassword) {
      this.$refs.modalLoadingSave.show();
      if (formPassword) {
        this.userProfile.password = formPassword.password;
        this.userProfile.confirmPassword = formPassword.confirmPassword;
      }
      let data = { userProfile: this.userProfile, roleId: this.roleId };
      await this.axios
        .post(`${this.$baseUrl}/adminRole/save`, data)
        .then((data) => {
          if (data.result) {
            this.$refs.modalLoadingSave.hide();
            this.$refs.modalSaveSuccess.show();
          } else {
            this.$refs.modalLoadingSave.hide();
            this.textAlert = data.detail[0];
            this.$refs.modalSaveAlert.show();
          }
        });
    },
    onSave() {
      this.roleId = [this.form.role];

      this.$v.userProfile.$touch();
      if (this.$v.userProfile.$error) return;
      this.saveData();
    },
    showModalResetPassword() {
      // this.$refs.modalResetPassword.show(
      //   this.userProfile.password,
      //   this.userProfile.confirmPassword
      // );

      this.$refs.modalResetPassword.show();
    },
    onRoleChange(data) {
      this.form.role = data;
    },
    checkPermission(menuID) {
      let roleSelect = this.rolePermission.filter(
        (role) => role.id == this.form.role
      )[0];
      for (let i = 0; i < roleSelect.permission.length; i++) {
        if (roleSelect.permission[i].id == menuID) {
          return true;
        }
      }
      return false;
    },
    showListPermission(index) {
      Object.assign(this.permissionMenu[index], {
        id: this.permissionMenu[index].id,
        name: this.permissionMenu[index].name,
        subMenu: [...this.permissionMenu[index].subMenu],
        show: true,
      });
    },
    hideListPermission(index) {
      Object.assign(this.permissionMenu[index], {
        id: this.permissionMenu[index].id,
        name: this.permissionMenu[index].name,
        subMenu: [...this.permissionMenu[index].subMenu],
        show: false,
      });
    },
  },
  validations() {
    return {
      userProfile: {
        firstname: { required, alpha },
        lastname: { required, alpha },
        email: { required, email },
        // employeeId: { required },
        password: {
          required: requiredIf(function() {
            return this.$route.params.id == 0;
          }),
          minLength: minLength(6),
          passwordNumber,
          alpha,
        },
        confirmPassword: {
          required: requiredIf(function() {
            return this.$route.params.id == 0;
          }),
          sameAsPassword: sameAs("password"),
          passwordNumber,
          alpha,
        },
      },
    };
  },
};
</script>

<style scoped>
.bg-border-top {
  border-top: 5px solid #8a44c3;
}
.date-section {
  display: flex;
  justify-content: flex-end;
}
.content-section {
  margin-top: 8px;
  padding: 24px;
  background-color: white;
}
.row-input {
  width: 100%;
  padding: 0px 4px 0px 4px;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
  min-height: 40px;
  min-width: 150px;
  transition: 0.3s;
}
.reset-pw {
  display: flex;
  align-items: center;
  height: 87%;
}
.switch-status {
  display: inline-flex;
  margin-bottom: 20px;
}
.txt-status {
  margin: 3px 0px 0px 5px;
}
.role {
  display: flex;
  align-items: center;
}
.permission-box {
  border: 1px solid #bcbcbc;
  height: 300px;
  overflow-y: auto;
}
.label-input {
  font-weight: bold;
  color: #404040;
}
</style>
